import { Middleware, UiState } from 'instantsearch.js';
import { HTMLAttributes, useEffect, useRef } from 'react';
import { useInstantSearch } from 'react-instantsearch';

type ScrollToProps = HTMLAttributes<HTMLDivElement>

export function ScrollTo({ children, className }: ScrollToProps) {
    const { addMiddlewares } = useInstantSearch();

    const containerRef = useRef<HTMLDivElement | null>(null);
    const previousStateRef = useRef<UiState | null>(null);

    useEffect(() => {
        const middleware: Middleware = ({ instantSearchInstance }) => {
            return {
                onStateChange({ uiState }) {
                    const indexName = instantSearchInstance.indexName;

                    const nextState = uiState[indexName];
                    const previousState = previousStateRef.current?.[indexName];

                    if (previousState?.page === nextState?.page) {
                        return;
                    }

                    containerRef.current!.scrollIntoView();

                    // Update previousStateRef with the current state
                    previousStateRef.current = uiState;
                },
            };
        };

        return addMiddlewares(middleware);
    }, [addMiddlewares]);

    return (
        <div ref={containerRef} className={className}>
            {children}
        </div>
    );
}